"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAECalendar = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _reactModernCalendarDatepicker = require("@hassanmojab/react-modern-calendar-datepicker");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

require("./FAECalendar.scss");

require("@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css");

const _excluded = ["justify", "align", "className", "todayClassName", "loading", "loaderProps", "getSelectedDate"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAECalendar = _ref => {
  let {
    justify,
    align,
    className = "",
    todayClassName = "",
    loading,
    loaderProps,
    getSelectedDate = () => {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [selectedDay, setSelectedDay] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (selectedDay !== null) {
      getSelectedDate("".concat(selectedDay.year, "-").concat("".concat(selectedDay.month).length === 1 ? "0".concat(selectedDay.month) : selectedDay.month, "-").concat("".concat(selectedDay.day).length === 1 ? "0".concat(selectedDay.day) : selectedDay.day));
    }
  }, [getSelectedDate, selectedDay]);
  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement(_reactModernCalendarDatepicker.Calendar, _extends({
    value: selectedDay,
    onChange: setSelectedDay,
    shouldHighlightWeekends: true,
    calendarClassName: "fae--custom-calendar-class ".concat(className),
    calendarTodayClassName: "fae--custom-today-day ".concat(todayClassName),
    colorPrimary: "#dc0000",
    minimumDate: (0, _reactModernCalendarDatepicker.utils)().getToday()
  }, rest)));
};

exports.FAECalendar = FAECalendar;